
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";
import { PaginacionProps } from "../global/PaginacionInterface";

// Definición de defaults

export const defaultDetalleListadoEnvioResponse: DetalleListadoEnvioResponse = {
    ...defaultHttpResponse,
    idListadoEnvio: 0,
    idEstatus: 0,
    asignadoMismoUsuario: false,
    usuarioAsignado: '',
    notificaciones: [],
    documento: ''
}

export const defaultBuscarListadoEnvioResponse: BuscarListadoEnvioResponse = {
    recordsCount: 0,
    currentPageIndex: 0,
    pageCount: 0,
    listadosEnvio: [],
}

export const defaultNuevoListadoEnvio: NuevoListadoEnvioResponse = {
    ...defaultHttpResponse,
    idListadoEnvio:     '',
}

export const defaultGenerarDocumentoListadoEnvio: GenerarDocumentoListadoEnvioResponse = {
    ...defaultHttpResponse,
    documento:  '',
}

// Creación de interfaces

export interface NuevoListadoEnvioResponse extends HttpResponse {
    idListadoEnvio: string;
}

export interface ListadoEnvioNotificacionProps {
    idNotificacion:            number;
    referencia:                string;
    otraReferencia:            string;
    personaNotificar:          string;
    tipoParte:                 string;
    tipoNotificacion:          string;
    tipoAcuerdo:               string;
    subTipoAcuerdo:            string;
    domicilio:                 string;        
    cedulaNotificacion:        string;
    acuerdo:                   string;
    selected:                  boolean;
    aceptada:                  boolean;
    motivoNoAceptada:          string;
    fechaNotificacion?:        Date;
}

export interface DetalleListadoEnvioResponse extends HttpResponse {
    idListadoEnvio:         number;
    documento:              string;
    idEstatus:              number;
    usuarioAsignado:        string;
    asignadoMismoUsuario:   boolean;
    notificaciones:         ListadoEnvioNotificacionProps[];
    fecha?:                 Date;
}

export interface GenerarListadoEnvioParams {
    idListadoEnvio:       string;
    notificaciones:       ListadoEnvioNotificacionProps[];
}

export interface GenerarDocumentoListadoEnvioResponse extends HttpResponse {
    documento: string;
}

export interface BuscarListadoEnvioParams extends PaginacionProps {
    fechaInicio:                string;
    fechaFin:                   string;
}

export interface BuscarListadoEnvioResponse {
    currentPageIndex:       number;
    pageCount:              number;
    recordsCount:           number;
    listadosEnvio:        ListadoEnvioProps[];
}

export interface ListadoEnvioProps {
    idListadoEnvio:       number;
    usuarioEnvia:         string;
    documento:            string;
    documentoRemesa:      string;
    notificaciones:       ListadoEnvioNotificacionProps[];
    fechaGeneracion?:     Date;
    fechaRemesa?:     Date;
}
